import { FormField, FormSearchSelect } from "@NP-Webber/crm-kit";
import "@NP-Webber/crm-kit/dist/formkit/FormKit.css";
import type { AssignableUser } from "../../../api/meetingsApi";
import { toDateInputValue } from "../constants";

export type ActionDraft = {
  clientKey?: string;
  id?: string;
  description: string;
  technicalDetails?: string;
  assignedToUserId?: string | null;
  dueDate?: string;
  createTask?: boolean;
  topicKey?: string | null;
};

type Props = {
  items: ActionDraft[];
  users: AssignableUser[];
  onChange: (items: ActionDraft[]) => void;
  canManage: boolean;
};

export function ActionItemsTable({ items, users, onChange, canManage }: Props) {
  const addRow = () => {
    onChange([
      ...items,
      {
        clientKey: `new-${Date.now()}`,
        description: "",
        technicalDetails: "",
        assignedToUserId: "",
        dueDate: "",
        createTask: true,
        topicKey: null,
      },
    ]);
  };

  const updateAt = (idx: number, field: keyof ActionDraft, value: unknown) => {
    const next = [...items];
    next[idx] = { ...next[idx], [field]: value };
    onChange(next);
  };

  const removeAt = (idx: number) => onChange(items.filter((_, i) => i !== idx));

  return (
    <div className="tm-panel">
      <div className="tm-panel__head">
        <h3 className="tm-panel__title">דרכי פעולה ({items.length})</h3>
        {canManage ? (
          <button type="button" className="tm-btn tm-btn--outline tm-btn--sm" onClick={addRow}>
            + הוסף משימה
          </button>
        ) : null}
      </div>
      {!items.length ? (
        <div className="tm-empty">הוסף דרכי פעולה עם שיוך אחריות</div>
      ) : (
        items.map((row, idx) => (
          <div key={row.clientKey || row.id || idx} className="tm-action-row">
            <FormField
              label="תיאור"
              value={row.description}
              onChange={(v) => updateAt(idx, "description", v)}
              disabled={!canManage}
            />
            <FormField
              label="פרטים טכניים"
              value={row.technicalDetails || ""}
              onChange={(v) => updateAt(idx, "technicalDetails", v)}
              disabled={!canManage}
            />
            <FormSearchSelect
              label="אחראי"
              options={users}
              value={
                users.find((u) => String(u.id) === String(row.assignedToUserId)) || null
              }
              onChange={(v) =>
                updateAt(idx, "assignedToUserId", (v as AssignableUser | null)?.id || "")
              }
              getOptionLabel={(o) => (o as AssignableUser).name}
              isOptionEqual={(a, b) =>
                (a as AssignableUser | null)?.id === (b as AssignableUser | null)?.id
              }
              disabled={!canManage}
            />
            <FormField
              label="תאריך יעד"
              type="date"
              value={toDateInputValue(row.dueDate)}
              onChange={(v) => updateAt(idx, "dueDate", v)}
              disabled={!canManage}
            />
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: "0.8125rem",
              }}
            >
              <input
                type="checkbox"
                checked={row.createTask !== false}
                onChange={(e) => updateAt(idx, "createTask", e.target.checked)}
                disabled={!canManage}
              />
              צור משימה במערכת
            </label>
            {canManage ? (
              <button
                type="button"
                className="tm-icon-btn tm-icon-btn--danger"
                onClick={() => removeAt(idx)}
              >
                ×
              </button>
            ) : null}
          </div>
        ))
      )}
    </div>
  );
}
